const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/eCheckin/ECheckinForm.tsx';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/sro/eCheckin/sections/PersAngaben';
import Arzt from 'App/config/sro/eCheckin/sections/Arzt';
import Versicherung from 'App/config/sro/eCheckin/sections/Versicherung';
import KontaktPerson from 'App/config/sro/eCheckin/sections/KontaktPerson';
import textMap from 'App/config/sro/eCheckin/translations';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import Finalize from 'App/config/sro/eCheckin/sections/Finalize';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';
import { Kostenuebernahme } from 'App/config/sro/eCheckin/sections/KostenUebernahme';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <KontaktPerson path="kontakt" title={textMap.kontakt} />
            <Arzt path="hausArzt" title={textMap.hausArzt} />
            <Versicherung path="versicherung" title={textMap.versicherungLabel} />
            <Kostenuebernahme path="kostenuebernahme" title={textMap.kostenuebernahme} />
            <Finalize path="_finalizeSection" title={textMap.finalizeTitle} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
